import { ChatWorkspace } from "@/components/ChatWorkspace";

export default function ConversacionesPage() {
  return (
    <div className="h-full" data-testid="conversaciones-page">
      <ChatWorkspace fullHeight />
    </div>
  );
}
